import { t } from "@lingui/core/macro";

import { PaymentToStatus } from "@/generated/api/users";

const getLocalizedPaymentStatus = (): Record<PaymentToStatus, string> => ({
  CANCELLED: t({ context: "payment status", id: "Zrušeno" }),
  COMPLETED: t({ context: "payment status", id: "Zaplaceno" }),
  ERROR: t({ context: "payment status", id: "Selhalo" }),
  INITIALIZED: t({ context: "payment status", id: "Založeno" }),
  REFUNDED: t({ context: "payment status", id: "Vráceno" }),
  WAITING: t({ context: "payment status", id: "Neuhrazeno" }),
});

export { getLocalizedPaymentStatus };
